import { sub } from 'date-fns';

export const MAX_EVENT_RECORDS = 10000;
export const MAX_EVENT_PAGES = 1000;

export const getDateRangePresets = () => {
  const Today = new Date();
  Today.setHours(0, 0, 0, 0);
  return [
    {
      label: 'Today',
      start: Today,
      end: Today,
    },
    {
      label: 'Last 7 days',
      start: sub(Today, { days: 7 }),
      end: Today,
    },
    {
      label: 'Last 1 month',
      start: sub(Today, { months: 1 }),
      end: Today,
    },
    {
      label: 'Last 6 months',
      start: sub(Today, { months: 6 }),
      end: Today,
    },
  ];
};
